import { useState } from 'react';
import './App.css';
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Game } from './components/game';
import { Settings } from './components/settings';

export interface GameConfig {
  color: string;
  maxTurns: number;
}

function App() {
  const [ startGame, setStartGame ] = useState(false);
  const [ gameConfig, setGameConfig ] = useState<GameConfig>({
    color: '',
    maxTurns: -1,
  });

  const handleSetConfig = (settings: Object) => {
    const config = {
      ...gameConfig,
      ...settings,
    };
    setGameConfig(config);
    setStartGame(true);
  };

  const restart = () => {
    setStartGame(false);
  };

  return (
    <div className="App">
      <header className="App-header">
        {
          startGame ? <Game gameConfig={gameConfig} restart={restart} />
          : <Settings setSettings={handleSetConfig} />
        }
      </header>
    </div>
  );
}

export default App;
